/** Incident verification and physical observations use different buyer labels. */

type ScanVerifyMeasurement = {
  numerator?: { value?: number; identity?: string | null };
  rate?: {
    value?: number | null;
    issuable?: boolean;
    withheld_reasons?: string[];
  };
} | null | undefined;

export function scanVerifyConfirmedCountLine(
  measurement: ScanVerifyMeasurement,
  verificationConfirmed?: number,
): string {
  const label = measurement?.numerator?.identity === 'incident'
    ? 'Confirmed incidents'
    : 'Confirmed observations';
  const value = Number(measurement?.numerator?.value ?? verificationConfirmed ?? 0);
  return `${label}: ${value}`;
}

export function scanVerifyRateLine(measurement: ScanVerifyMeasurement): string {
  if (measurement?.rate?.issuable) {
    const unit = measurement.numerator?.identity === 'incident'
      ? 'confirmed incidents per usable hour (incident verification, not a physical measurement)'
      : 'confirmed observations per usable hour';
    return `Rate: ${measurement.rate?.value} ${unit}`;
  }
  const reasons = measurement?.rate?.withheld_reasons;
  return `Rate withheld${reasons?.length ? `: ${reasons.join(', ')}` : '.'}`;
}
